/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Sidebar } from "primereact/sidebar";
import { Button } from "primereact/button";
import { TabPanel, TabView } from "primereact/tabview";
import moment from "moment";

import useForm from "../../shared/forms/useForm";
import Field from "../../shared/forms/Field";
import Form from "../../shared/forms/Form";
import FormTabView from "../../shared/forms/Tabs/FormTabView";
import ReadOnlyProvider from "../../shared/forms/ReadOnlyProvider";
import ExGrid from "../../shared/Grid/ExGrid";
import ExColumn from "../../shared/Grid/ExColumn";
import { fechaUtc } from "../../shared/Grid/GridCellRenderers";
import YupValidator from "../../shared/YupValidator";

import useApiSalidasEmpleado from "../../api/administracion/useApiSalidasEmpleado";
import GeneralSalidaEmpleado from "./Edicion/generalSalidaEmpleado";
import salidaEmpleadoValidacionEsquema from "./salidaEmpleadoValidacionEsquema";

const ESTATUS_SALIDA = {
    POR_AUTORIZAR: 171,
    AUTORIZADO: 172,
    RECHAZADO: 173,
    SALIDA: 430
};

const obtenerId = (value) => {
    if (value === null || value === undefined || value === "") return null;
    if (typeof value === "object") return value.id ?? value.Id ?? null;
    return value;
};

const SalidasEmpleadoDetalle = ({
    salidaEmpleadoId,
    onCancel,
    onSaved,
    puedeEditar
}) => {
    const api = useApiSalidasEmpleado();
    const validador = new YupValidator(salidaEmpleadoValidacionEsquema());

    const initialValues = {
        salidaEmpleado: {
            id: 0,
            empleadoId: null,
            nombreCompleto: "",
            departamentoId: null,
            fechaHoraSalida: moment().toDate(),
            jefeInmediato: "",
            jefeInmediatoId: null,
            destino: "",
            tipoId: null,
            motivos: "",
            comentarios: "",
            historial: []
        }
    };

    const visible = salidaEmpleadoId !== null;

    const [submitted, setSubmitted] = useState(false);
    const [errors, setErrors] = useState({});

    const {
        values: item,
        setValues,
        onChange,
        onValidate,
        isValid
    } = useForm(initialValues);

    const normalizarDetalle = (result) => {
        return {
            ...result,
            empleadoId: obtenerId(result?.empleadoId),
            departamentoId: obtenerId(result?.departamentoId),
            jefeInmediatoId: obtenerId(result?.jefeInmediatoId),
            tipoId: obtenerId(result?.tipoId),
            fechaHoraSalida: result?.fechaHoraSalida
                ? moment(result.fechaHoraSalida).toDate()
                : null,
            historial: result?.historial ?? []
        };
    };

    const onLoad = async () => {
        setSubmitted(false);
        setErrors({});

        if (salidaEmpleadoId === 0 || salidaEmpleadoId === null) {
            setValues(initialValues);
            return;
        }

        const result = await api.obtener(salidaEmpleadoId);

        setValues({
            salidaEmpleado: normalizarDetalle(result)
        });
    };

    useEffect(() => {
        onLoad().then();
    }, [salidaEmpleadoId]);

    const construirPayload = () => {
        const salida = item?.salidaEmpleado ?? {};

        return {
            id: salida.id ?? 0,
            empleadoId: obtenerId(salida.empleadoId),
            nombreCompleto: salida.nombreCompleto,
            departamentoId: obtenerId(salida.departamentoId),
            fechaHoraSalida: salida.fechaHoraSalida,
            jefeInmediato: salida.jefeInmediato,
            jefeInmediatoId: obtenerId(salida.jefeInmediatoId),
            destino: salida.destino,
            tipoId: obtenerId(salida.tipoId),
            motivos: salida.motivos,
            comentarios: salida.comentarios
        };
    };

    const onSave = async () => {
        setSubmitted(true);

        const payload = construirPayload();

        if (await validador.validate(payload) === false) {
            setErrors(validador.errors);
            return;
        }

        if (!isValid) return;

        if (payload.id > 0) {
            await api.actualizar(payload.id, payload);
        } else {
            await api.guardar(payload);
        }

        onSaved();
    };

    const estatusId = item?.salidaEmpleado?.estatusId;

    const puedeGuardar =
        puedeEditar &&
        (
            !estatusId ||
            estatusId === ESTATUS_SALIDA.POR_AUTORIZAR
        );

    return (
        <>
            <Sidebar
                visible={visible}
                position="right"
                dismissable={false}
                className="p-sidebar-bg"
                onHide={onCancel}
                style={{ width: "1350px" }}
            >
                <TabView>
                    <TabPanel header="Pase de salida">
                        <ReadOnlyProvider>
                            <Form
                                columns={1}
                                values={item}
                                onChange={onChange}
                                onValidate={onValidate}
                                submitted={submitted}
                                formDisabled={!puedeGuardar}
                                className={`form-container full-height ${submitted ? "submitted" : ""}`}
                            >
                                <FormTabView>
                                    <Field
                                        title="General"
                                        field="salidaEmpleado"
                                        render={(props) => (
                                            <GeneralSalidaEmpleado
                                                {...props}
                                                puedeEditar={puedeGuardar}
                                                errors={errors}
                                                submitted={submitted}
                                            />
                                        )}
                                    />
                                </FormTabView>
                            </Form>
                        </ReadOnlyProvider>
                    </TabPanel>

                    <TabPanel header="Historial">
                        <ExGrid data={item?.salidaEmpleado?.historial ?? []}>
                            <ExColumn title="Acción" field="accion" />
                            <ExColumn title="Usuario" field="auditUser" />
                            <ExColumn title="Fecha" field="fechaUtc" cellRenderer={fechaUtc} />
                            <ExColumn title="Comentario" field="comentario" />
                        </ExGrid>
                    </TabPanel>
                </TabView>

                <div className="form-footer">
                    <Button
                        label="Salir"
                        onClick={onCancel}
                        className="p-button-outlined"
                    />

                    {puedeGuardar && (
                        <Button
                            label="Guardar"
                            type="button"
                            onClick={onSave}
                        />
                    )}
                </div>
            </Sidebar>
        </>
    );
};

export default SalidasEmpleadoDetalle;